<template>
  <!-- O COMPONENTE NÃO POSSUI VALIDAÇÕES (COMPRIMENTO E SEQUÊNCIA VÁLIDA) POIS ACEITA COMPRIMENTO PARCIAL -->
  <NxInput
    name="cep"
    type="text"
    label="CEP:"
    placeholder="EX: 17280000"
    :value="localValue"
    v-mask="['#####-###']"
    @update:value="handleValueUpdate"
    @change="onSearchCep"
    :isDisabled="isDisabled"
  ></NxInput>
</template>

<script>
import CepRepository from '@/shared/http/repositories/external/cep.js'
import { loading, toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxInputCep',
  mixins: [useReactiveModelMixin('value')],
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    },
    async onSearchCep () {
      if (this.localValue) {
        try {
          loading.push()

          const { data } = await CepRepository.GetCEP(
            this.localValue.replace(/[^a-zA-Z0-9 ]/g, '')
          )

          this.$emit('endereco', data)
        } catch (err) {
          toast.error(
            'Não foi possível carregar o endereço com base no CEP',
            'Erro'
          )
          console.error(err)
        } finally {
          loading.close()
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputCep.vue